<template>
  <div class="collapse_text" :class="{'collapse_text-less': isLessMode, 'collapse_text-more': isMoreMode}">
    <div
        ref="text"
        class="collapse_text__text pseudo_input pseudo_input-dark"
        v-text="value"
        :style="style"
    ></div>
    <div class="collapse_text__control" @click.stop="toggle">
      <i class="fas fa-chevron-down ml-2 mr-1" v-if="isLessMode"></i>
      <i class="fas fa-chevron-up" v-if="isMoreMode"></i>
    </div>
  </div>
</template>

<script>
const modes = {
  less: 1,
  more: 2,
}

export default {
  props: {
    value: null,
    maxHeight: Number,
  },

  data() {
    return {
      mode: modes.less,
    }
  },

  computed: {
    /**
     * @return {Object}
     */
    style() {
      const styles = {
        'max-height': this.maxHeight ? `${this.maxHeight}px` : null,
        'overflow': this.isMoreMode ? 'auto' : null,
      };

      return _.pickBy(styles);
    },

    /**
     * @return {boolean}
     */
    isOverfull() {
      const el = this.$refs.text;
      return el.scrollWidth !== el.width;
    },

    /**
     * @return {string}
     */
    controlText() {
      switch (this.mode) {
        case modes.less:
          return 'more';
        case modes.more:
          return 'less';
        default:
          return '';
      }
    },

    /**
     * @return {boolean}
     */
    isLessMode() {
      return this.mode === modes.less;
    },

    /**
     * @return {boolean}
     */
    isMoreMode() {
      return this.mode === modes.more;
    },

    test() {
      return {
        scrollWidth: this.$refs.text.scrollWidth,
        width: this.$refs.text.width,
      };
    },
  },

  methods: {
    toggle() {
      this.mode = this.isLessMode ? modes.more : modes.less;
    },
  },
}
</script>
